import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import { ToolFilterGroup } from '../styles';

export const HistoryWrapper = styled(Stack)`
  width: 100%;
  gap: 24px;
`;

/** Back button, title and subtitle, stacked on narrow screens */
export const HeaderRow = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: '12px',
  flexDirection: 'row',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
  },
}));

export const HeaderTitleStack = styled(Stack)({
  alignItems: 'flex-start',
  gap: '4px',
});

export const HistoryFilterGroup = styled(ToolFilterGroup)({
  flexWrap: 'wrap',
  height: 'auto',

  '.MuiToggleButtonGroup-grouped': {
    minHeight: '40px',
    borderRadius: 0,
  },
});

/** Centered column used by the empty and error states */
export const StateWrapper = styled(Stack)`
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 16px;
  text-align: center;
`;

/** Chip marking which tool produced a row */
export const HistoryStateChip = styled(Chip)({
  borderRadius: '4px',
  height: '24px',
  fontWeight: 600,
});

/** History table cell text */
export const HistoryTextTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.white['06'],
}));

/** History table result text, wraps rather than overflowing the cell */
export const HistoryResultTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.white['06'],
  wordBreak: 'break-word',
}));

/** Flex row layout for table cells with icon and text */
export const TableRowAlignStack = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
});
